import { assocPath } from 'ramda';

import constants from '../constants';

export const initialState = {
  form: {
    username: '',
    password: '',
  },
  logoPath: '',
  loginPath: '',
  error: '',
  errors: {
    username: false,
    password: false,
  },
  processing: false,
  redirecting: false,
  readyToSubmit: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.ON_CHANGE: {
      const { name, value } = action.payload;
      return assocPath(['form', name], value, state);
    }

    case constants.HIGHLIGHT_ERRORS: {
      const { errors, name } = action.payload;
      if (name) {
        return assocPath(['errors', name], errors, state);
      } else {
        return {
          ...state,
          errors,
        };
      }
    }

    case constants.PROMISE_SUBMIT_START: {
      return {
        ...state,
        processing: true,
        error: '',
      };
    }

    case constants.PROMISE_SUBMIT_ERROR: {
      return {
        ...state,
        processing: false,
        error: 'fail',
        form: {
          ...state.form,
          password: '',
        },
      };
    }

    case constants.PROMISE_SUBMIT_SUCCESS: {
      window.location.reload();

      return {
        ...state,
        error: '',
        processing: false,
        redirecting: true,
      };
    }

    case constants.SET_READY_TO_SUBMIT: {
      return {
        ...state,
        setReadyToSubmit: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
